
//
// Modal Controller
//
// Makes basics of modals work and invokes specific modal controllers depending
// on the modal type coincident with appropriate events.
//

module.exports = function ModalController ($page, $$) {

  // Dom
  var $triggers = $$('[data-modal-trigger]');
  var $modals   = $$('[data-modal]');

  // Functions
  function invoke (name, params) {
    $modals.filter(function (it, el) {
      if (el.dataset.modal === name) {
        var modal = getWidgetAtDom(el);
        if (modal) modal.invoke(params);
      }
    });
  }

  function onTriggerClicked (event) {
    var name   = event.target.dataset.modalTrigger;
    var params = JSON.parse(log(event.target.dataset.modalParams.replace(/→/g, '"')));
    log('ModalController::onTriggerClicked -', name, params);
    invoke(name, params);
  }

  // Listeners
  $triggers.on('click', onTriggerClicked);

};

